import { h } from "@stencil/core";
import { mouseEventModifierKey } from "../../../../components/common/helpers";
/**
 * The `ch-grid-column-resize` component responsible for resizing a column in a grid.
 * @deprecated Use `ch-tabular-grid` component instead. Use `ch-tabular-grid-column-resize` instead.
 */
export class ChGridColumnResize {
    constructor() {
        this.resizing = false;
        this.column = undefined;
    }
    startPageX;
    mousemoveFn = this.mousemoveHandler.bind(this);
    el;
    /**
     * Event emitted when the user starts resizing the column.
     */
    columnResizeStarted;
    /**
     * Event emitted when the user is resizing the column.
     */
    columnResizing;
    /**
     * Event emitted when the user finishes resizing the column.
     */
    columnResizeFinished;
    componentDidLoad() {
        this.el.addEventListener("mousedown", this.mousedownHandler.bind(this));
    }
    clickHandler(eventInfo) {
        eventInfo.stopPropagation();
    }
    dblclickHandler(eventInfo) {
        eventInfo.stopPropagation();
        if (mouseEventModifierKey(eventInfo)) {
            this.column.size = "auto";
        }
        else {
            this.column.size = "max-content";
        }
    }
    columnResizeStartedHandler() {
        this.resizing = true;
    }
    columnResizeFinishedHandler() {
        this.resizing = false;
    }
    mousedownHandler(eventInfo) {
        eventInfo.stopPropagation();
        eventInfo.preventDefault();
        this.startPageX = eventInfo.pageX;
        document.addEventListener("mousemove", this.mousemoveFn, { passive: true });
        document.addEventListener("mouseup", this.mouseupHandler.bind(this), {
            once: true
        });
        this.columnResizeStarted.emit({ columnId: this.column.columnId });
    }
    mousemoveHandler(eventInfo) {
        this.columnResizing.emit({
            columnId: this.column.columnId,
            deltaWidth: this.startPageX - eventInfo.pageX
        });
    }
    mouseupHandler() {
        document.removeEventListener("mousemove", this.mousemoveFn);
        this.columnResizeFinished.emit({ columnId: this.column.columnId });
    }
    render() {
        return h("div", { key: '3882af9f52bf7a8fca4cda22865b39083f800dab', class: "resize-mask", hidden: !this.resizing });
    }
    static get is() { return "ch-grid-column-resize"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-column-resize.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-column-resize.css"]
        };
    }
    static get properties() {
        return {
            "column": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLChGridColumnElement",
                    "resolved": "HTMLChGridColumnElement",
                    "references": {
                        "HTMLChGridColumnElement": {
                            "location": "global",
                            "id": "global::HTMLChGridColumnElement"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The column element that is being resized."
                }
            }
        };
    }
    static get states() {
        return {
            "resizing": {}
        };
    }
    static get events() {
        return [{
                "method": "columnResizeStarted",
                "name": "columnResizeStarted",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the user starts resizing the column."
                },
                "complexType": {
                    "original": "ChGridColumnResizeEvent",
                    "resolved": "ChGridColumnResizeEvent",
                    "references": {
                        "ChGridColumnResizeEvent": {
                            "location": "import",
                            "path": "../ch-grid-column-types",
                            "id": "src/deprecated-components/grid/grid-column/ch-grid-column-types.ts::ChGridColumnResizeEvent"
                        }
                    }
                }
            }, {
                "method": "columnResizing",
                "name": "columnResizing",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the user is resizing the column."
                },
                "complexType": {
                    "original": "ChGridColumnResizeEvent",
                    "resolved": "ChGridColumnResizeEvent",
                    "references": {
                        "ChGridColumnResizeEvent": {
                            "location": "import",
                            "path": "../ch-grid-column-types",
                            "id": "src/deprecated-components/grid/grid-column/ch-grid-column-types.ts::ChGridColumnResizeEvent"
                        }
                    }
                }
            }, {
                "method": "columnResizeFinished",
                "name": "columnResizeFinished",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the user finishes resizing the column."
                },
                "complexType": {
                    "original": "ChGridColumnResizeEvent",
                    "resolved": "ChGridColumnResizeEvent",
                    "references": {
                        "ChGridColumnResizeEvent": {
                            "location": "import",
                            "path": "../ch-grid-column-types",
                            "id": "src/deprecated-components/grid/grid-column/ch-grid-column-types.ts::ChGridColumnResizeEvent"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "clickHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }, {
                "name": "dblclick",
                "method": "dblclickHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "columnResizeStarted",
                "method": "columnResizeStartedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "columnResizeFinished",
                "method": "columnResizeFinishedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
